// Module
var code = "<div layout=\"column\" class=\"full-height\"> <bringoz-service-areas-view flex permission=\"'branches.update'\" branch-id=\"$ctrl.branch.id\" selected-area-ids=\"$ctrl.serviceAreaIds\" on-change=\"$ctrl.onServiceAreaChange(updatedAreas)\"> </bringoz-service-areas-view> </div> ";
// Exports
export default code;